// BUG-2564: the B2B entry in the customer drawers (GSTIN search text, the matched B2B
// company, the validated GST details, the picked invoice / delivery address) belongs to
// one cart and one customer. Left over, it carried a GSTIN typed for one bill into the
// next bill's drawer, where turning B2B on validated it for a different customer.

// The cart and customer a B2B entry belongs to. Changes on bill completion, new cart,
// retrieve, and customer add / remove / change.
export const b2bEntryOwnerKey = (cart) => `${cart?.sOrderID || ""}|${cart?.customer?.cwrCustomerId || ""}`;

// True when the cart has no customer of its own: none, or the till's default (walk-in)
// customer. Same test as SMCustomerBar's isDefaultCustomer.
export const isDefaultCartCustomer = (cart, tillData) =>
  !cart?.customer?.cwrCustomerId || cart.customer.cwrCustomerId === tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId;

// BUG-2601: true when the cart's customer carries a company a B2B bill can be sent with
// (sCustomer.sCustomerID or newB2bCustomerId, the ids the order builders read). The till's
// default customer can have a company of its own (24 of 25 GPR stores): that one is not a
// business customer. A default customer with ANOTHER company is: GPR bills B2B on the
// walk-in customer with the buyer's company (30 live orders, 30 days to 2026-10-13).
export const cartHasBusinessCustomer = (cart, tillData) => {
  const ids = [cart?.customer?.sCustomer?.sCustomerID, cart?.customer?.newB2bCustomerId].filter(Boolean);
  if (ids.length === 0) return false;
  if (!isDefaultCartCustomer(cart, tillData)) return true;
  const ownCompanyId = tillData?.tillAccess?.csBunit?.b2cCustomer?.sCustomer?.sCustomerID || null;
  return ids.some((id) => id !== ownCompanyId);
};

// BUG-2601: the B2B flag (local storage + useTransactionStore) survives a reload. It
// belongs to a saved customer on the cart; on a cart with the default customer and no
// company other than its own it is left over from a drawer that never saved (or an older
// build that wrote it on toggle).
// Called once after the stores are restored. Returns true when it cleared the flag.
export const clearB2bFlagForDefaultCustomer = ({ cart, exchangeCart, tillData, transactionStore }) => {
  if (!tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId) return false;
  const keepsFlag = (c) => !isDefaultCartCustomer(c, tillData) || cartHasBusinessCustomer(c, tillData);
  if (exchangeCart?.customer && keepsFlag(exchangeCart)) return false;
  if (keepsFlag(cart)) return false;
  const stored = localStorage.getItem("isB2bEnabled");
  const inStore = transactionStore.getState().isB2bEnabled;
  if (stored === null && inStore === null) return false;
  localStorage.removeItem("isB2bEnabled");
  transactionStore.getState().setIsB2bEnabled(null);
  return true;
};

// True when the cashier turned B2B on and entered B2B details in this drawer session,
// but nothing has been saved as B2B yet (isB2bEnabled is written to local storage and the
// transaction store only by a successful customer save -- BUG-2601).
export const hasUnsavedB2BEntry = ({ isB2BEnabled, lastSearchedValue, gstInfo, selectedB2BCustomer, storedB2B }) =>
  !!isB2BEnabled && !storedB2B && (!!String(lastSearchedValue || "").trim() || !!gstInfo || !!selectedB2BCustomer);
